// src/redux/store.js
import { configureStore } from "@reduxjs/toolkit";
import contactReducer from "./ContactSlice";
import authReducer from "./LoginSlice";
import galleryReducer from "./GallerySlice";
import categoryReducer from "./CategorySlice";
import BlogReducer from "./BlogSlice";

const store = configureStore({
  reducer: {
    auth: authReducer,
    contact: contactReducer,
    gallery: galleryReducer,
    category: categoryReducer,
    blog: BlogReducer,
  },
});

export default store;
